<template>
    <v-menu ref="menu">
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                :disabled="!item.selected"
                v-on="on"
            >
                mdi-chevron-down
            </v-icon>
            <v-btn
                icon
                small
            >
                <v-icon :color="item.color">
                    mdi-circle
                </v-icon>
            </v-btn>
        </template>
        <v-list
            outlined
            left
            max-width="300px"
        >
            <v-list-item>
                <v-list-item-content>
                    <v-row no-gutters>
                        <v-col
                            v-for="color in menucolors"
                            :key="color.color"
                            cols="2"
                            class="text-center pa-1"
                        >
                            <v-btn
                                icon
                                small
                            >
                                <v-icon
                                    :color="color.color"
                                    @click="updateItemColor(item, color)"
                                >
                                    mdi-circle
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { getColorCatalog } from '@/utils/ticketTypeColors';
export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
        };
    },
    computed: {
        menucolors() {
            return getColorCatalog();
        },
    },
    methods: {
        updateItemColor(item, color) {
            this.$emit('updateItemColor', item, color);
        },
    },
};
</script>